





































































































































































































































import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";

@Component
export default class BasePopup extends Vue {
  /**
   * State of the popup
   * @values true false
   */
  @Prop({ required: true })
  private show!: boolean;

  /**
   * Popup icon url, optional
   */
  @Prop({ default: require("@/assets/icons/popup/alert.png") })
  private icon!: string;

  private timeoutId: any;

  private beforeLeftClose = false;
  private beforeRightClose = false;
  private beforeBottomClose = false;

  /**
   * If the close action was called by swiping left
   */
  private onSwipeLeft() {
    this.beforeLeftClose = true;

    this.closeWithPause();
  }

  /**
   * If the close action was called by swiping right
   */
  private onSwipeRight() {
    this.beforeRightClose = true;

    this.closeWithPause();
  }

  /**
   * If the close action was called in default way
   */
  private onCommonClose() {
    this.beforeBottomClose = true;

    this.closeWithPause();
  }

  private closeWithPause() {
    this.timeoutId = setTimeout(() => {
      this.$emit("on-close");

      this.beforeLeftClose = false;
      this.beforeRightClose = false;
      this.beforeBottomClose = false;
    }, 450);
  }

  private destroyed() {
    clearTimeout(this.timeoutId);
  }
}
